import Card from "./Card";

export default function FilterPanel({ children, title, className = "" }) {
  return (
    <Card padding="p-4" className={`mb-6 ${className}`}>
      {title && (
        <h3 className="text-lg font-semibold text-text mb-4">{title}</h3>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {children}
      </div>
    </Card>
  );
}
